import React from "react";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

import "./Contacto.css";

function Contacto() {
  const mensajeWhatsApp =
    "Bienvenido a G&J FRÍO INDUSTRIAL. Da clic en Ir al Chat para comunicarte con nosotros.";

  const whatsapp1 = `https://wa.me/593939979333?text=${encodeURIComponent(
    mensajeWhatsApp,
  )}`;

  const whatsapp2 = `https://wa.me/593981443171?text=${encodeURIComponent(
    mensajeWhatsApp,
  )}`;

  return (
    <div className="contacto-page">
      <Navbar />

      <main>
        {/* =====================================================
            ENCABEZADO
        ===================================================== */}
        <section className="contacto-hero">
          <div className="contacto-container">
            <div className="contacto-hero-content">
              <div>
                <span className="contacto-kicker">ESTAMOS PARA AYUDARTE</span>

                <h1>Contáctanos</h1>

                <p>
                  Estamos siempre cerca para atenderte. Escríbenos, llámanos o
                  visítanos en nuestro local.
                </p>
              </div>

              <div className="contacto-hero-icon">
                <i className="bi bi-headset"></i>
              </div>
            </div>
          </div>
        </section>

        {/* =====================================================
            MAPA E INFORMACIÓN
        ===================================================== */}
        <section className="contacto-main-section">
          <div className="contacto-container">
            <div className="contacto-section-header">
              <div>
                <span className="contacto-section-kicker">UBICACIÓN</span>

                <h2>Encuéntranos en Machala</h2>

                <p>
                  Visítanos en nuestro establecimiento o comunícate directamente
                  con nuestro equipo.
                </p>
              </div>

              <div className="contacto-header-line"></div>
            </div>

            <div className="contacto-main-grid">
              {/* MAPA */}
              <div className="contacto-map-card">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d798.7494806297926!2d-79.9533494637231!3d-3.2569191834526316!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x90330ffc56e29069%3A0x5e23c86c5713c932!2sG%26J%20FRIO%20INDUSTRIAL!5e1!3m2!1ses!2sec!4v1752007814067!5m2!1ses!2sec"
                  title="Ubicación G&J Frío Industrial"
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              {/* INFORMACIÓN */}
              <aside className="contacto-info-card">
                <div className="contacto-info-header">
                  <span className="contacto-info-main-icon">
                    <i className="bi bi-building"></i>
                  </span>

                  <div>
                    <span>NUESTRA OFICINA</span>
                    <h3>G&amp;J Frío Industrial</h3>
                  </div>
                </div>

                <div className="contacto-info-list">
                  <div className="contacto-info-item">
                    <span className="contacto-info-icon">
                      <i className="bi bi-geo-alt-fill"></i>
                    </span>

                    <div>
                      <strong>Dirección</strong>

                      <p>
                        Junín 425 E/ Marcel Laniado y Kleber Franco, Machala.
                      </p>
                    </div>
                  </div>

                  <div className="contacto-info-item">
                    <span className="contacto-info-icon">
                      <i className="bi bi-telephone-fill"></i>
                    </span>

                    <div>
                      <strong>Teléfonos</strong>

                      <div className="contacto-phone-links">
                        <a href="tel:+593939979333">0939979333</a>

                        <span>-</span>

                        <a href="tel:+593981443171">0981443171</a>
                      </div>
                    </div>
                  </div>

                  <div className="contacto-info-item">
                    <span className="contacto-info-icon">
                      <i className="bi bi-envelope-fill"></i>
                    </span>

                    <div>
                      <strong>Correo electrónico</strong>

                      <a href="mailto:gonzaloivanal@gmail.com">
                        gonzaloivanal@gmail.com
                      </a>
                    </div>
                  </div>
                </div>

                {/* WHATSAPP */}
                <div className="contacto-whatsapp">
                  <span className="contacto-whatsapp-label">
                    Atención por WhatsApp
                  </span>

                  <div className="contacto-whatsapp-buttons">
                    <a
                      href={whatsapp1}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contacto-whatsapp-button"
                    >
                      <i className="bi bi-whatsapp"></i>

                      <span>
                        <small>WhatsApp</small>
                        0939979333
                      </span>
                    </a>

                    <a
                      href={whatsapp2}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contacto-whatsapp-button"
                    >
                      <i className="bi bi-whatsapp"></i>

                      <span>
                        <small>WhatsApp</small>
                        0981443171
                      </span>
                    </a>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </section>

        {/* =====================================================
            INFORMACIÓN ADICIONAL
        ===================================================== */}
        <section className="contacto-details-section">
          <div className="contacto-container">
            <div className="contacto-section-header">
              <div>
                <span className="contacto-section-kicker">
                  INFORMACIÓN DE CONTACTO
                </span>

                <h2>Estamos cerca de ti</h2>

                <p>
                  Consulta nuestra ubicación, horarios de atención y medios de
                  contacto.
                </p>
              </div>

              <div className="contacto-header-line"></div>
            </div>

            <div className="contacto-details-grid">
              {/* UBICACIÓN */}
              <article className="contacto-detail-card">
                <div className="contacto-detail-top">
                  <span className="contacto-detail-icon">
                    <i className="bi bi-geo-alt-fill"></i>
                  </span>

                  <span className="contacto-detail-number">01</span>
                </div>

                <h3>Nuestra ubicación</h3>

                <p>Machala, El Oro, Ecuador.</p>
              </article>

              {/* HORARIO */}
              <article className="contacto-detail-card">
                <div className="contacto-detail-top">
                  <span className="contacto-detail-icon">
                    <i className="bi bi-clock-fill"></i>
                  </span>

                  <span className="contacto-detail-number">02</span>
                </div>

                <h3>Horario de atención</h3>

                <div className="contacto-schedule-list">
                  <div>
                    <span>Lunes - Viernes</span>
                    <strong>8:00 AM - 6:00 PM</strong>
                  </div>

                  <div>
                    <span>Sábados</span>
                    <strong>8:00 AM - 5:00 PM</strong>
                  </div>

                  <div>
                    <span>Domingos</span>
                    <strong>8:00 AM - 1:00 PM</strong>
                  </div>
                </div>
              </article>

              {/* EMAIL */}
              <article className="contacto-detail-card">
                <div className="contacto-detail-top">
                  <span className="contacto-detail-icon">
                    <i className="bi bi-envelope-fill"></i>
                  </span>

                  <span className="contacto-detail-number">03</span>
                </div>

                <h3>Escríbenos</h3>

                <p>
                  También puedes enviarnos un correo y responderemos lo antes
                  posible.
                </p>

                <a
                  href="mailto:gonzaloivanal@gmail.com"
                  className="contacto-email-link"
                >
                  <i className="bi bi-envelope"></i>
                  gonzaloivanal@gmail.com
                </a>
              </article>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <WhatsAppButton />
    </div>
  );
}

export default Contacto;
